import React from "react";
import {StandardLayout} from "../../components/StandardLayout";
import {PermissionGuard} from "../../components/PermissionGuard";
import {ContactFeature} from "../../features/contact";

const ALLOWED_PERMISSION = 'contact'

const ContactPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <StandardLayout
      headerTitle="各類組業務窗口"
      body={<ContactFeature />}
    />
  </PermissionGuard>
)

export default ContactPage
